import React, {  useEffect, useRef, useState} from 'react';
import apiClient from '../../services/apiClient';




const PayPalButtonComponent = ({payment}) => {
  const [paypalid, setpaypalid] = useState();

  const [payamount, setpayamount] = useState(0);
  const paypalRef = useRef(null);
  const paypalButtonInstance = useRef(null);

  const validPayment = Number(payment);

  useEffect(() => {

    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);
        setpaypalid(response.data.usersdetails[0].paypal_id);
    
      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchuserdata();
    
    }, []);

    useEffect(() => {
      setpayamount(payment);
    }, [payment]);


    useEffect(() => {
      // Load the PayPal SDK script dynamically
      if (!window.paypal) {
        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD`;
        script.onload = () => {
          initializePayPalButton();
        };
        document.body.appendChild(script);
      } else {
        initializePayPalButton();
      }
  
      function initializePayPalButton() {
        if (paypalButtonInstance.current) {
          // Cleanup the existing PayPal button
          paypalButtonInstance.current.innerHTML = '';
        }
  
        // Create and render PayPal button
        paypalButtonInstance.current = window.paypal.Buttons({
          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: payamount // Use dynamic amount
                },
                payee: {
                  email_address: paypalid // Set the seller's PayPal email address here
                }
              }]
            });
          },
          onApprove: function (data, actions) {
            return actions.order.capture().then(function (details) {
              alert('Transaction completed by ' + details.payer.name.given_name);
            });
          },
          onError: function (err) {
            console.error('PayPal Button Error:', err);
          }
        }).render(paypalRef.current);
      }
  
      // Cleanup on component unmount
      return () => {
        if (paypalRef.current) {
          paypalRef.current.innerHTML = '';
        }
      };
    }, []); // Re-run effect when `amount` changes

  return (<div>
    <div ref={paypalRef}></div> {/* Use ref to track the PayPal button container */}
  </div>);
};

export default PayPalButtonComponent;
